module.exports = __webpack_public_path__ + "img/mung-dhal-with-spinach.2e1e7968.jpg";